import { RootState } from "store/root-reducer";

export const currentHq = ({ superHq }: RootState) => superHq.superHq;

export const selectSuperHqId = ({ superHq }: RootState) => superHq.superHq?.id;
